import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FaStore, FaUser, FaRegCommentDots } from 'react-icons/fa';

const navItems = [
  {
    label: 'Marketplace',
    to: '/marketplace',
    icon: <FaStore className="w-6 h-6" />,
  },
  {
    label: 'My Account',
    to: '/profile',
    icon: <FaUser className="w-6 h-6" />,
  },
  {
    label: 'Chat',
    to: '/messages',
    icon: <FaRegCommentDots className="w-6 h-6" />,
  },
];

const MobileFooterBar = () => {
  const location = useLocation();
  
  // Hide the footer on messages page
  if (location.pathname === '/messages' || location.pathname.startsWith('/messages')) {
    return null;
  }
  
  return (
    <nav className="fixed bottom-0 left-0 right-0 z-50 md:hidden w-full">
      <div className="flex justify-between items-center bg-white rounded-2xl shadow-xl px-2 py-1 relative">
        {navItems.map((item) => {
          const isActive = location.pathname.startsWith(item.to);
          return (
            <Link
              key={item.to}
              to={item.to}
              className={`flex flex-col items-center flex-1 py-1 transition group ${isActive ? '' : 'text-gray-500'}`}
            >
              <div className={`flex items-center justify-center w-10 h-8 rounded-xl transition-all duration-200 ${isActive ? 'bg-red-500 text-white shadow-lg' : 'bg-transparent text-gray-500 group-hover:text-red-500'}`}>
                {item.icon}
              </div>
              <span className={`text-xs mt-1 font-medium ${isActive ? 'text-red-600' : 'text-gray-500 group-hover:text-red-500'}`}>{item.label}</span>
            </Link>
          );
        })}
      </div>
    </nav>
  );
};

export default MobileFooterBar; 